var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 15.678a11.25 11.25 0 10-13.008 11.114v-7.864h-2.856v-3.25h2.857v-2.479a3.97 3.97 0 014.25-4.375c.843.012 1.685.085 2.518.22v2.766h-1.42a1.625 1.625 0 00-1.834 1.757v2.11h3.125l-.5 3.25h-2.625v7.862a11.25 11.25 0 009.493-11.111z",
    fill: "#D9D9D9"
  })));
}
export default __webpack_public_path__ + "assets/static/media/facebook.9ed7e0ce.svg";
export { SvgFacebook as ReactComponent };